export default __webpack_public_path__ + "static/media/icon_mail_confirm.759d0051.svg";